import React, { Component } from 'react';
import chroma from 'chroma-js';
import moment from 'moment';
import numeral from 'numeral';

class Receipts extends Component {
  state = {
    loaded: false,
    receipts: [],
    customerEdit: {}
  };

  componentWillMount() {
    this.setState({
      token: this.getQueryStringParamName('token'),
      customerId: this.getQueryStringParamName('customer'),
      colors: this.getColors()
    });
  }

  componentDidMount() {
    if (this.state.token && this.state.customerId) {
      this.loadCustomer();
      this.loadReceipts();
    }
  }

  formatCurrency = value => numeral(value).format('$0,0.00');
  formatMonth = (year, month) => moment(new Date(year, month - 1)).format('MMMM YYYY');

  getColor(name, defaultValue) {
    let value = this.getQueryStringParamName(name);

    if (!value || !value.match(/^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/i)) {
      value = defaultValue;
    }

    return `#${value}`;
  }

  getColors() {
    return {
      text: this.getColor('text-color', '333'),
      background: this.getColor('background-color', 'fff'),
      border: this.getColor('border-color', 'ddd'),
      focusBorder: this.getColor('focus-border-color', '66afe9'),
      buttonText: this.getColor('button-text-color', 'fff'),
      buttonBackground: this.getColor('button-background-color', '337ab7'),
      link: this.getColor('link-color', '337ab7'),
      panelHeader: this.getColor('panel-header-color', 'f5f5f5'),
      alternateBackground: this.getColor('alternate-background-color', 'f5f5f5')
    };
  }

  getQueryStringParamName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');

    const regex = new RegExp("[?&]" + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return '';

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  handleCustomerChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    const customerEdit = this.state.customerEdit;
    customerEdit[name] = value;

    this.setState({ customerEdit });
  }

  handleSaveChangesClick = event => {
    const customerEdit = this.state.customerEdit;

    const customer = {
      name: customerEdit.name,
      address: {
        line1: customerEdit.addressLine1,
        line2: customerEdit.addressLine2,
        city: customerEdit.addressCity,
        state: customerEdit.addressState,
        zip: customerEdit.addressZip,
        country: customerEdit.addressCountry
      },
      vat: customerEdit.vat,
      extraInfo: customerEdit.extraInfo
    };

    this.saveCustomer(customer)
      .then(() => {
        this.setState({ customer });
        this.loadReceipts();
      });
  }

  loadCustomer() {
    fetch(`/customers/${this.state.token}/${this.state.customerId}`, {
        headers: {
          'Accept': 'application/json'
        }
      })
      .then(res => res.json())
      .then(customer => {
        let customerEdit = {
          name: customer.name,
          addressLine1: customer.address.line1,
          addressLine2: customer.address.line2,
          addressCity: customer.address.city,
          addressState: customer.address.state,
          addressZip: customer.address.zip,
          addressCountry: customer.address.country,
          vat: customer.vat,
          extraInfo: customer.extraInfo
        };

        this.setState({
          customer,
          customerEdit
        });
      })
      .catch(error => {
        this.setState({
          errorCustomer: 'Error loading customer data. Customer id might be wrong. ' + error
        });
      });
  }

  loadReceipts() {
    fetch(`/receipts/${this.state.token}/${this.state.customerId}`, {
        headers: {
          'Accept': 'application/json'
        }
      })
      .then(res => res.json())
      .then(receipts => {
        if (receipts.error) {
          this.setState({
            errorReceipts: receipts.error,
            loaded: true,
            receipts: []
          });
        } else {
          this.setState({
            loaded: true,
            receipts: receipts || []
          });
        }
      })
      .catch(error =>
        this.setState({
          loaded: true,
          errorReceipts: 'Error loading receipts. Customer id might be wrong. ' + error,
          receipts: []
        })
      );
  }

  saveCustomer(customer) {
    let headers = new Headers();
    headers.append('Content-type', 'application/json');
    headers.append('Accept', 'application/json');

    let params = {
      method: 'POST',
      headers,
      body: JSON.stringify(customer)
    };

    return fetch(`/customers/${this.state.token}/${this.state.customerId}`, params)
      .then(res => res.json());
  }

  render() {
    let missingData =
      <div className="alert alert-warning text-center">
        You need to provide <code>token</code> and <code>customer</code>.
      </div>

    let loading =
      <div className="loader">
        Loading data...
      </div>

    let errorReceipts =
      <div className="alert alert-danger text-center">
        {this.state.errorReceipts}
      </div>

    let errorCustomer =
      <div className="alert alert-danger text-center">
        {this.state.errorCustomer}
      </div>

    let receiptsList =
      <div className="panel panel-default">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Month</th>
              <th className="text-right">Amount</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {this.state.receipts.map(receipt =>
              <tr key={receipt.year + '/' + receipt.month}>
                <td>
                  {this.formatMonth(receipt.year, receipt.month)}
                </td>
                <td className="text-right">
                  {this.formatCurrency(receipt.totalAmount)}
                </td>
                <td className="text-right">
                  <a title="Download PDF"
                    href={receipt.pdfUrl + '&download=true'} target="_blank" rel="noopener noreferrer">Download</a>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

    let customerEditor =
      <div className="panel panel-default">
        <div className="panel-heading">Company information</div>
        <div className="panel-body">
          <div className="form-group">
            <label className="control-label">Name</label>
            <input className="form-control" value={this.state.customerEdit.name}
                   name="name" onChange={this.handleCustomerChange} />
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label className="control-label">Address line 1</label>
                <input className="form-control" value={this.state.customerEdit.addressLine1}
                      name="addressLine1" onChange={this.handleCustomerChange} />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label className="control-label">Address line 2</label>
                <input className="form-control" value={this.state.customerEdit.addressLine2}
                      name="addressLine2" onChange={this.handleCustomerChange} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label className="control-label">City</label>
                <input className="form-control" value={this.state.customerEdit.addressCity}
                       name="addressCity" onChange={this.handleCustomerChange} />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="form-group">
                <label className="control-label">State</label>
                <input className="form-control" value={this.state.customerEdit.addressState}
                       name="addressState" onChange={this.handleCustomerChange} />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="form-group">
                <label className="control-label">Zip</label>
                <input className="form-control" value={this.state.customerEdit.addressZip}
                       name="addressZip" onChange={this.handleCustomerChange} />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label">Country</label>
            <input className="form-control" value={this.state.customerEdit.addressCountry}
                   name="addressCountry" onChange={this.handleCustomerChange} />
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label className="control-label">VAT number</label>
                <input className="form-control" value={this.state.customerEdit.vat}
                      name="vat" onChange={this.handleCustomerChange} />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label className="control-label">Extra info</label>
                <input className="form-control" value={this.state.customerEdit.extraInfo}
                      name="extraInfo" onChange={this.handleCustomerChange} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <button className="btn btn-primary" onClick={this.handleSaveChangesClick}>Save</button>
            </div>
          </div>
        </div>
      </div>

    let data =
      <div>
        <div className="row">
          <div className="col-sm-6">
            {this.state.errorReceipts ? errorReceipts : ""}
            {!this.state.loaded ? loading : receiptsList}
          </div>
          <div className="col-sm-6">
            {this.state.errorCustomer ? errorCustomer : ""}
            {!this.state.customer ? loading : customerEditor}
          </div>
        </div>
      </div>

    let colors = this.state.colors;
    let styles =
      <style dangerouslySetInnerHTML={{__html: `
        body {
          background: ${colors.background};
          color: ${colors.text};
        }

        a {
          color: ${colors.link};
        }
        a:hover, a:active, a:focus, a:visited {
          color: ${chroma(colors.link).darken()};
        }

        table {
          border-radius: 3px;
        }

        .table > thead > tr > th {
          background: ${colors.panelHeader};
          border-bottom: 0;
          padding-top: 10px;
          padding-bottom: 10px;
        }

        .table-striped > tbody > tr:nth-of-type(2n+1) {
          background-color: ${colors.background};
        }

        .table-striped > tbody > tr:nth-of-type(2n) {
          background-color: ${colors.alternateBackground};
        }

        .btn-primary {
          background-color: ${colors.buttonBackground};
          border-color: ${chroma(colors.buttonBackground).darken(0.5)};
          color: ${colors.buttonText};
        }

        .btn-primary:hover, .btn-primary:active, .btn-primary:focus {
          background-color: ${chroma(colors.buttonBackground).darken(0.5)};
          border-color: ${chroma(colors.buttonBackground).darken()};
          color: ${colors.buttonText};
        }

        .panel {
          background: ${colors.background};
          border-color: ${colors.border};
        }

        .panel-default .panel-heading {
          background: ${colors.panelHeader};
          border-color: ${colors.border};
          color: ${colors.text};
          font-weight: bold;
        }

        .form-control {
          background: ${colors.background};
          border-color: ${colors.border};
          color: ${colors.text};
        }

        .form-control:focus {
          border-color: ${colors.focusBorder};
          -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px ${chroma(colors.focusBorder).alpha(0.6).css()};
          box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px ${chroma(colors.focusBorder).alpha(0.6).css()};
        }

        .table > tbody > tr > td,
        .table > tbody > tr > th,
        .table > tfoot > tr > td,
        .table > tfoot > tr > th,
        .table > thead > tr > td,
        .table > thead > tr > th {
          border-color: ${colors.border};
        }
      `}}>
      </style>

    let content = (this.state.token && this.state.customerId) ? data : missingData;

    return <div>
        {styles}
        {content}
      </div>
  }
}

export default Receipts;



// WEBPACK FOOTER //
// ./src/ReceiptsList.js